import profile from "../../src/components/profile/pages/profile";
import publicProfile from "../../src/components/profile/pages/public-profile";
import privacy from "../../src/components/profile/pages/privacy";
import password from "../../src/components/profile/pages/password";
import committees from "../../src/components/profile/pages/committees";
import groups from "../../src/components/profile/pages/groups";
import itemgroups from "../../src/components/profile/pages/itemgroups";
import items from "../../src/components/profile/pages/items";
import responsibilities from "../../src/components/profile/pages/responsibilities";
import subscriptions from "../../src/components/profile/pages/subscriptions";
import payments from "../../src/components/profile/pages/payments";
import permissions from "../../src/components/profile/pages/permissions";
import messages from "../../src/components/profile/pages/messages/index";
import message from "../../src/components/profile/pages/messages/show";
import subscriptionPayments from "../../src/components/profile/pages/subscription-payments";
import subscriptionPayment from "../../src/components/profile/pages/subscription-payment";

export default [
  {
    path: "create",
    component: profile,
    meta: {
      AuthRequired: true,
      roles: ["Ledenadministratie"],
    },
  },
  {
    path: ":id/edit",
    component: profile,
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
      checkOwner: true,
      checkCanEdit: true,
    },
  },
  {
    path: ":id/password",
    component: password,
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
      checkOwner: true,
    },
  },
  {
    path: ":id/subscriptions",
    component: subscriptions,
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie", "Financieel"],
    },
  },
  {
    path: ":id/payments",
    component: payments,
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie", "Financieel"],
    },
  },
  {
    path: ":id/view",
    component: profile,
    name: "profile",
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
      checkOwner: true,
    },
  },
  {
    path: ":id/public-view",
    component: publicProfile,
    meta: {
      AuthRequired: true,
    },
  },
  {
    path: ":id/privacy",
    component: privacy,
    name: "user.privacy",
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
      checkOwner: true,
    },
  },
  {
    path: ":id/committees",
    component: committees,
    meta: {
      Breadcrumb: "Commissies",
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
      checkOwner: true,
    },
  },
  {
    path: ":id/groups",
    component: groups,
    meta: {
      Breadcrumb: "Groepen",
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
      checkOwner: true,
    },
  },
  {
    path: ":id/itemgroups",
    component: itemgroups,
    meta: {
      Breadcrumb: "Itemgroepen",
      AuthRequired: true,
    },
  },
  {
    path: ":id/items",
    component: items,
    meta: {
      Breadcrumb: "Items",
      AuthRequired: true,
    },
  },
  {
    path: ":id/responsibilities",
    component: responsibilities,
    meta: {
      Breadcrumb: "Taken",
      AuthRequired: true,
    },
  },
  {
    path: ":id/permissions",
    component: permissions,
    meta: {
      AuthRequired: true,
      permissions: ["Ledenadministratie"],
    },
  },
  {
    path: ":id/messages",
    component: messages,
    meta: {
      AuthRequired: true,
    },
  },
  {
    path: ":id/messages/:messageId",
    component: message,
    meta: {
      AuthRequired: true,
    },
  },
  {
    path: ":id/subscriptions/:subscription_id/payments",
    component: subscriptionPayments,
    meta: {
      AuthRequired: true,
    },
  },
  {
    path: ":id/subscriptions/:subscription_id/payment/:payment_id",
    name: "subscription-payment",
    component: subscriptionPayment,
    meta: {
      AuthRequired: true,
    },
  },
];
